import script from "./QrImage.vue?vue&type=script&setup=true&lang=js"
export * from "./QrImage.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__